import React from 'react';

const EnhancedLink = ({ url, isDarkMode }) => {
    if (!url) return null;

    // Helper to truncate long URLs for display
    const getDisplayUrl = (url) => {
        try {
            const urlObj = new URL(url);
            return urlObj.hostname + (urlObj.pathname.length > 20 ? urlObj.pathname.substring(0, 20) + '...' : urlObj.pathname);
        } catch (e) {
            const s = url ? String(url) : '';
            return s.length > 30 ? s.substring(0, 30) + '...' : s;
        }
    };

    const displayUrl = getDisplayUrl(url);

    // Helper to download file
    const handleDownload = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = url.split('/').pop() || 'download';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(blobUrl);
            document.body.removeChild(a);
        } catch (error) {
            console.error('Download failed:', error);
            // Fallback to opening in new tab if download fails (CORS issues etc)
            window.open(url, '_blank');
        }
    };

    return (
        <span className={`inline-flex items-center gap-2 max-w-full my-1 p-2 rounded-lg border align-middle ${isDarkMode
                ? 'bg-gray-800 border-gray-700 hover:border-gray-600'
                : 'bg-white border-gray-200 hover:border-gray-300'
            } transition-colors group shadow-sm`}>
            {/* Icon based on file type or generic link */}
            <span className={`p-2 rounded-md ${isDarkMode ? 'bg-gray-700 text-cyan-400' : 'bg-gray-100 text-cyan-600'
                }`}>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                </svg>
            </span>

            <span className="flex-1 min-w-0 inline-flex flex-col">
                <span className={`text-sm font-medium truncate ${isDarkMode ? 'text-gray-200' : 'text-gray-800'
                    }`}>
                    {displayUrl}
                </span>
                <span className={`text-xs truncate ${isDarkMode ? 'text-gray-500' : 'text-gray-500'
                    }`}>
                    Click to open or download
                </span>
            </span>

            <span className="inline-flex items-center gap-1 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
                {/* Open Button */}
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`p-1.5 rounded-md transition-colors ${isDarkMode
                            ? 'hover:bg-gray-700 text-gray-400 hover:text-white'
                            : 'hover:bg-gray-100 text-gray-500 hover:text-gray-900'
                        }`}
                    title="Open in new tab"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                </a>

                {/* Download Button */}
                <button
                    onClick={handleDownload}
                    className={`p-1.5 rounded-md transition-colors ${isDarkMode
                            ? 'hover:bg-gray-700 text-gray-400 hover:text-white'
                            : 'hover:bg-gray-100 text-gray-500 hover:text-gray-900'
                        }`}
                    title="Download"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                </button>
            </span>
        </span>
    );
};

export default EnhancedLink;
